import * as React from "react";

class Syncronizer {

  protected readonly syncronizers = {
    EVENT: "syncEvent",
    VALUE: "syncValue",
    CHECKBOX: "syncCheckbox",
    ROLE: "syncRole",
    TLS: "syncTls",
    TYPE: "syncType",
    UNIT_TYPE: "syncUnitType",
    STATUS: "syncStatus",
    CURRENCY: "syncCurrency",
    REPEAT_PERIOD: "syncRepeatPeriod",
    PERIOD: "syncPeriod",
    PAYMENT_OFFSET: "syncPaymentOffset",
    PAYMENT_TYPE: "syncPaymentType",
    CHARGE_CLASS: "syncChargeClass",
    IDENTITY_TYPE: "syncIdentityType",
    GENDER_TYPE: "syncGenderType",
    LANGUAGE_TYPE: "syncLanguageType",
  };

  public getSyncronizers() {
    return this.syncronizers;
  }

  public sync(...args: any[]): void {
    const component: React.Component<any, any> = args.shift();
    const configuration: any = typeof args[0] === "object" ? args.shift() : {};
    const syncronizer: string = args.shift();
    const parameters: any[] = args;
    if (this.constructor.prototype.hasOwnProperty(syncronizer) === false) {
      throw new Error(`Syncronizer ${syncronizer} is missing the implementation.`);
    }

    if (configuration.ignoreModification === true || parameters.includes("amazonFolderName") === true) {
      component.setState({
        hasModifiedData: false
      });
    } else {
      component.setState({
        hasModifiedData: true
      });
    }

    return this[syncronizer].call(this, component, ...parameters);
  }

  protected syncEvent(component: React.Component<any, any>, property: string | string[], event: any): void {

    if (typeof property === "string") {
      component.setState({
        [property]: event.currentTarget.value,
        descriptionManuallyChanged: true
      });
      return;
    }

    property.forEach(property => {
      component.setState({
        [property]: event.currentTarget.value
      });
    });
  }

  protected syncValue(component: React.Component<any, any>, property: string, value: any): void {
    component.setState({
      [property]: value,
      hasModifiedData: true
    });
  }

  protected syncCheckbox(component: React.Component<any, any>, property: string, event): void {
    component.setState({
      [property]: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncRole(component: React.Component<any, any>, event) {
    component.setState({
      role: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncTls(component: React.Component<any, any>, event) {
    component.setState({
      imapTls: Number(event.target.value)
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncType(component: React.Component<any, any>, event) {
    if (!event.target.value) {
      return;
    }
    component.setState({
      type: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncUnitType(component: React.Component<any, any>, event) {
    component.setState({
      unitType: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncStatus(component: React.Component<any, any>, event) {
    component.setState({
      status: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncCurrency(component: React.Component<any, any>, event) {
    component.setState({
      currency: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncRepeatPeriod(component: React.Component<any, any>, event) {
    component.setState({
      repeatPeriod: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncPeriod(component: React.Component<any, any>, event) {
    component.setState({
      period: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncPaymentOffset(component: React.Component<any, any>, event) {
    component.setState({
      paymentOffset: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncPaymentType(component: React.Component<any, any>, event) {
    component.setState({
      paymentType: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncChargeClass(component: React.Component<any, any>, event) {
    component.setState({
      chargeClass: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncIdentityType(component: React.Component<any, any>, event) {
    component.setState({
      identityType: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncGenderType(component: React.Component<any, any>, event) {
    component.setState({
      genderTypeId: event.target.value
    });
  }

  // @todo seems too duplicated. Fix sometime later. CASA-1236
  protected syncLanguageType(component: React.Component<any, any>, event) {
    component.setState({
      languageTypeId: event.target.value
    });
  }
}

export default new Syncronizer();
